import Head from "next/head";
import { GetStaticProps } from "next";

import CarrierDetails from "@/components/carriers/carrier-details";
import carriersData from "@/data/carriers.json";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";
import { CarrierType } from "@/@types/CarrierType";

type Props = {
  carrier: CarrierType;
};

export default function Carrier({ carrier }: Props) {
  return (
    <>
      <Head>
        <title>{seoData.CARRIER.title}</title>
        <SeoMetaData
          data={{
            ...seoData.CARRIER,
            canonicalUrl: `${seoData.CARRIER.canonicalUrl}/${carrier?.slug}`,
          }}
        />
      </Head>

      <CarrierDetails carrierContent={carrier} />
    </>
  );
}

export async function getStaticPaths() {
  // Generate the paths for each news item
  const paths = carriersData.map((carrier) => {
    return {
      params: { carrier: carrier.slug },
    };
  });

  return {
    paths,
    fallback: true,
  };
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  if (!params || !params.carrier) {
    return {
      notFound: true,
    };
  }

  const carrier = carriersData.find(({ slug }) => slug === params.carrier);

  if (!carrier) {
    return {
      notFound: true,
    };
  }

  return {
    props: { carrier },
  };
};
